import Vue from 'vue'
import Keyboard from './keyboard'
import Global from './global'
import Directives from '@/directives'
import FormCreate from '@mg/mg-fc-designer/dist/render/element-ui/form-create.es'
import request from '@/utils/request'
Vue.use(Global)
Vue.use(Directives)
Vue.use(Keyboard)
Vue.use(FormCreate)
FormCreate.extendApi(api => api.$pcRequest = request)